import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Calendar as CalendarIcon } from '@gravity-ui/icons';
import { Button, Icon, Popup, useFocusWithin } from '@gravity-ui/uikit';
import { Calendar } from '../Calendar';
import { DateField } from '../DateField';
import { getButtonSizeForInput } from '../utils/getButtonSizeForInput';
import { i18n } from './i18n';
import { b } from './utils';
export function DesktopCalendar({ anchorRef, props, state }) {
    var _a;
    const { focusWithinProps } = useFocusWithin({
        isDisabled: !state.isOpen,
        onBlurWithin: () => {
            state.setOpen(false);
        },
    });
    if (!state.hasDate) {
        return null;
    }
    return (_jsx(Popup, { open: state.isOpen, anchorRef: anchorRef, onClose: () => {
            state.setOpen(false);
        }, restoreFocus: true, children: _jsxs("div", Object.assign({}, focusWithinProps, { className: b('popup-content'), children: [_jsx(Calendar
                // eslint-disable-next-line jsx-a11y/no-autofocus
                , { 
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus: true, size: props.size === 's' ? 'm' : props.size, disabled: props.disabled, readOnly: props.readOnly, onUpdate: (d) => {
                        state.setDateValue(d);
                    }, defaultFocusedValue: (_a = state.dateValue) !== null && _a !== void 0 ? _a : undefined, value: state.dateValue, minValue: props.minValue, maxValue: props.maxValue, isDateUnavailable: props.isDateUnavailable, timeZone: props.timeZone }), state.hasTime && (_jsx("div", { className: b('time-field-wrapper'), children: _jsx(DateField, { className: b('time-field'), size: props.size, readOnly: props.readOnly, value: state.timeValue, onUpdate: state.setTimeValue, placeholderValue: props.placeholderValue, minValue: props.minValue, maxValue: props.maxValue, timeZone: props.timeZone, format: state.timeFormat }) }))] })) }));
}
export function DesktopCalendarButton({ props, state }) {
    const wasOpenBeforeClickRef = React.useRef(false);
    if (!state.hasDate) {
        return null;
    }
    return (_jsx(Button, { view: "flat", size: getButtonSizeForInput(props.size), disabled: props.disabled, extraProps: {
            'aria-label': i18n('Calendar'),
            'aria-haspopup': 'dialog',
            'aria-expanded': state.isOpen,
        }, onFocus: () => {
            wasOpenBeforeClickRef.current = state.isOpen;
        }, onClick: () => {
            if (!wasOpenBeforeClickRef.current) {
                state.setOpen(true);
            }
            wasOpenBeforeClickRef.current = false;
        }, children: _jsx(Icon, { data: CalendarIcon }) }));
}
